// Module
var code = "<branches></branches>\n";
// Exports
module.exports = code;